
import { WithStyles, withStyles } from "@material-ui/core/styles";
import * as React from "react";
import Component from "../../../components/Component";
import withAxios, { IAxiosProps } from "../../../components/withAxios";
import Headerpage from "src/components/header";
import Footerpage from "src/components/footer";
import "src/pages/home/signUp-pages/style.css";
import { AppContextConsumer, IAppContext } from "src/components/withAppContext";
import { withRouter } from "react-router-dom";
// import ArrowIcon from "src/assets/Arrow.png";
import LoadingSpinner from "src/components/LoadingSpinner";
// import { ZENDDESK_FAQ } from "src/constants";
// import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Box } from '@material-ui/core/';
// import { Edit } from '@material-ui/icons-material';
const styles = () => ({
    childTemplate: {
        paddingLeft: 80,
    },
    listItem: {
        "&:hover": {
            backgroundColor: "#e6e6e6",
        },
        backgroundColor: "white",
    },
});

type IProps = IAxiosProps & IAppContext &
    WithStyles<keyof ReturnType<typeof styles>> & { history: any };

interface ITemplatesPageState {
    subscriptionPlan: any,
    getAllPlanData: any
    loader: boolean;
    redirectAddon: boolean
    showBuyButton: boolean;

}

const Home = withStyles(styles)(
    withAxios(
        class PricePage extends Component<IProps, ITemplatesPageState> {
            public state = this.buildState({
                subscriptionPlan: {},
                getAllPlanData: [],
                loader: false,
                redirectAddon: false,
                showBuyButton: false
            });
            public componentWillMount(): void {
                this.props.getNewLoginUserDetails()
            }
            public componentDidMount() {
                this.getAllPlanHandler()
                window.addEventListener('scroll', this.handleScroll);
                // Check initial scroll position
                this.checkScrollPosition();
            }

            public componentWillUnmount() {
                window.removeEventListener('scroll', this.handleScroll);
            }

            public checkScrollPosition = () => {
                const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
                if (scrollPosition > 100 || !this.state.loader) {
                    this.setState({ showBuyButton: true });
                }
            }

            public handleScroll = () => {
                const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
                if (scrollPosition > 100) {
                    this.setState({ showBuyButton: true });
                }
            }

            public async getAllPlanHandler() {
                this.setState({ loader: true })
                const res: any = await this.buildGet(this, "payment/getPlan")()
                if (res.status && res?.data?.length > 0) {
                    const data = res.data.sort((a: any, b: any) => a.id - b.id);
                    this.setState({ getAllPlanData: data })
                    this.setState({ loader: false }, () => {
                        // Show buttons after data loads
                        this.setState({ showBuyButton: true });
                        // Scroll down after page load

                        // setTimeout(() => {
                        //     window.scrollTo({ top: 300, behavior: 'smooth' });
                        // }, 100);
                    })
                } else {
                    this.setState({ loader: false }, () => {
                        // Show buttons after data loads
                        this.setState({ showBuyButton: true });
                        // Scroll down after page load

                        // setTimeout(() => {
                        //     window.scrollTo({ top: 300, behavior: 'smooth' });
                        // }, 100);
                    })
                }
                // this.setState({ user: res })
            }

            public getFrequentyType(price: any, key: any) {
                switch (key) {
                    case "free":
                        return "Free"
                    case "yearly":
                        return `$${price}/yr`
                    default:
                        return ""
                }
            }
            public buyPlanHandler(plan: any) {
              
                this.props.onChangeUserDetails({
                    ...this.props?.newUserDetails,
                    subscriptionPlan: plan,
                    addonPlan: [],
                    addonPlanDetails:[]
                });
                this.setState({ subscriptionPlan: plan }, () => {
                    const pageRedirect = this.manageRedirectHandler()
                    this.props.history.push(pageRedirect)

                })
                // window.scrollTo({ top: 0, behavior: 'smooth' });
            }
            
            public starterPlanRender(item: any, index: any) {
                const tempSelect = item?.select !== null ? JSON.parse(item?.select) : []
                return (
                   
                    <div className="col-lg-3 pl-0" key={index}>
                        <div className="start-main-div">
                            <div className="starter">
                                <div className="starter-content">
                                    <div className="fa-icon-dev">
                                        <i className="fa-blue fa-solid fa-circle" />
                                        <i className="fa-grey fa-solid fa-circle" />
                                        <i className="fa-grey fa-solid fa-circle" />
                                        <i className="fa-grey fa-solid fa-circle" />
                                    </div>
                                    <div className="price-dev">
                                        <div className="price-inner-content">
                                            <h5>{this.getFrequentyType(item.price, item.payment_frequency_type)}</h5>
                                        </div>

                                    </div>
                                </div>
                                <div className="starter-inner-part">
                                    <div className="starter-inner-content">
                                        <h2>{item.title}</h2>
                                        <p>{item?.description}</p>
                                        <h4>What’s Included? </h4>
                                        <div className="start-list">
                                            <ul>
                                                {/* <li><i className="fa-regular fa-circle-check" /><h5>Unlimited storage and surveys for up to 5 coaches</h5></li> */}
                                                {/* <li><i className="fa-regular fa-circle-check" /><h5>Printable custom reports</h5></li> */}
                                                {/* <li><i className="fa-regular fa-circle-check" /><h5>Preloaded questions</h5></li> */}
                                                {
                                                    tempSelect.length > 0 ? tempSelect.map((itm: any) => {
                                                        return <li key={item?.id}><i className="fa-regular fa-circle-check" /><h5>{itm}</h5></li>

                                                    }) : null
                                                }

                                            </ul>
                                            {this.state.showBuyButton && (
                                                <div className="buy-now-div">
                                                    {/* <Link to="/starterpage"> */}
                                                    <button className="buy-now-btn" onClick={() => {
                                                        this.buyPlanHandler(item)
                                                    }}><span>Buy Now</span></button>
                                                    {/* </Link> */}

                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>)

            }
            public proPlanRender(item: any, index: any) {
                const tempSelect = item?.select !== null ? JSON.parse(item?.select) : []
                return (
                    <div className="col-lg-3 pl-0">
                        <div className="pro">
                            <div className="starter">
                                <div className="starter-content">
                                    <div className="fa-icon-dev">
                                        <i className="fa-grey fa-solid fa-circle" />
                                        <i className="fa-blue fa-solid fa-circle" />
                                        <i className="fa-grey fa-solid fa-circle" />
                                        <i className="fa-grey fa-solid fa-circle" />
                                    </div>
                                    <div className="price-dev">
                                        <div className="price-inner-content">
                                            <h5>{this.getFrequentyType(item.price, item.payment_frequency_type)}</h5>
                                        </div>

                                    </div>
                                </div>
                                <div className="starter-inner-part">
                                    <div className="starter-inner-content">
                                        <h2>{item?.title}</h2>
                                        <p>{item?.description}</p>
                                        <h4>What’s Included? </h4>
                                        <div className="start-list">
                                            <ul className="pro-ul">
                                                {
                                                    tempSelect.length > 0 ? tempSelect.map((itm: any) => {
                                                        return <li key={item?.id}><i className="fa-regular fa-circle-check" /><h5>{itm}</h5></li>

                                                    }) : null
                                                }

                                            </ul>
                                            {this.state.showBuyButton && (
                                                <div className="buy-now-div">
                                                    {/* <Link to="/propage"> */}
                                                    <button className="buy-now-btn" onClick={() => {
                                                        this.buyPlanHandler(item)
                                                    }}><span>Buy Now</span></button>
                                                    {/* </Link> */}

                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
            
            public premierPlanRender(item: any, index: any) {
                const tempSelect = item?.select !== null ? JSON.parse(item?.select) : []
                return (<div className="col-lg-3 pl-0">
                    <div className="premier">
                        <div className="starter">
                            <div className="starter-content">
                                <div className="fa-icon-dev">
                                    <i className="fa-grey fa-solid fa-circle" />
                                    <i className="fa-grey fa-solid fa-circle" />
                                    <i className="fa-blue fa-solid fa-circle" />
                                    <i className="fa-grey fa-solid fa-circle" />
                                </div>
                                <div className="price-dev">
                                    <div className="price-inner-content">
                                        <h5>{this.getFrequentyType(item.price, item.payment_frequency_type)}</h5>
                                    </div>

                                </div>
                            </div>
                            <div className="starter-inner-part">
                                <div className="starter-inner-content">
                                    <div className="most-popular" style={{flexDirection: "column"}}>
                                        <div>
                                    <h2 style={{marginBottom: "0"}}>{item?.title}</h2>
                                    </div>
                                    <div className="most-inner-popular">
                                        <h4>Most Popular</h4>
                                    </div>
                                    </div>
                                    <p>{item?.description}</p>
                                    <h4>What’s Included? </h4>
                                    <div className="start-list">
                                        <ul className="premier-ul">
                                            {
                                                tempSelect.length > 0 ? tempSelect.map((itm: any) => {
                                                    return <li key={item?.id}><i className="fa-regular fa-circle-check" /><h5>{itm}</h5></li>

                                                }) : null
                                            }
                                        </ul>
                                        <div className="buy-now-div">
                                            {/* <Link to="/premierpage">  */}
                                            <button className="buy-now-btn" onClick={() => {
                                                this.buyPlanHandler(item)
                                            }}><span>Buy Now</span></button>
                                            {/* </Link> */}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>)
            }

            public elitePlanRender(item: any, index: any) {
                const tempSelect = item?.select !== null ? JSON.parse(item?.select) : []
                return (
                    <div className="col-lg-3 pl-0">
                        <div className="elite">
                            <div className="starter">
                                <div className="starter-content">
                                    <div className="fa-icon-dev">
                                        <i className="fa-grey fa-solid fa-circle" />
                                        <i className="fa-grey fa-solid fa-circle" />
                                        <i className="fa-grey fa-solid fa-circle" />
                                        <i className="fa-blue fa-solid fa-circle" />
                                    </div>
                                    <div className="price-dev">
                                        <div className="price-inner-content">
                                            <h5>{this.getFrequentyType(item.price, item.payment_frequency_type)}</h5>
                                        </div>

                                    </div>
                                </div>
                                <div className="elite-inner-part">
                                    <div className="elite-inner-content">
                                        <h2>{item?.title}</h2>
                                        <p>{item?.description}</p>
                                        <h4>What’s Included? </h4>
                                        <div className="elite-list">
                                            <ul className="elite-ul">
                                                {
                                                    tempSelect.length > 0 ? tempSelect.map((itm: any) => {
                                                        return <li key={item?.id}><i className="fa-regular fa-circle-check" /><h5>{itm}</h5></li>

                                                    }) : null
                                                }
                                            </ul>
                                            <div className="buy-now-div">
                                                <button className="buy-now-btn" onClick={() => {
                                                    this.buyPlanHandler(item)
                                                }}><span>Buy Now</span></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
            public planRenderUI(item: any, index: any) {
                switch (item.id) {
                    case 2:
                        return this.starterPlanRender(item, index)
                    case 3:
                        return this.proPlanRender(item, index)
                    case 4:
                        return this.premierPlanRender(item, index)
                    case 5:
                        return this.elitePlanRender(item, index)
                    default:
                        return null
                }
            }
            public manageRedirectHandler() {
                const id = this.state.subscriptionPlan?.id
                switch (id) {
                    case 1:
                        return "/purchase"
                    case 2:
                        return "/starterpage"
                    case 3:
                        return "/starterpage"
                    case 4:
                        return "/starterpage"
                    case 5:
                        // return "/purchase"
                        return "/starterpage"
                    default:
                        return ""
                }
            }
            public render() {
                return (
                    <>
                   
                    <div className="contat-main-bg-color">
  {this.state.loader &&<div className="loader-bg-color">
    <LoadingSpinner /></div>}

                       <Headerpage/>
                        <div className="container">
                        <div className="containerr">
                              {/* {
                                this.state.getAllPlanData?.filter((item: any) => item?.id === 1).map((item: any, index: number) => {
                                    return (
                                        <div className="content-price" key={index}>
                                            <div className="free-now">
                                                <h2  onClick={() => {
                                                    this.buyPlanHandler(item)
                                                }}>START FOR FREE NOW!</h2>


                                            </div>
                                        </div>
                                    )
                                })
                            } */}

                            <div className="pricing-main-div"> 
                                <h4 className="chooseplan-forsignin">Choose a Plan</h4>
                                <div className="row align-items-end p-4">
                                    {
                                        this.state.getAllPlanData?.filter((item: any) => item?.id !== 1).map((item: any, index: number) => {
                                            return this.planRenderUI(item, index)
                                        })
                                    }
                                    {/* <div className="col-lg-3">
                                        <div className="pro">
                                            <div className="starter">
                                                <div className="starter-content">
                                                    <div className="fa-icon-dev">
                                                        <i className="fa-blue fa-solid fa-circle" />
                                                        <i className="fa-grey fa-solid fa-circle" />
                                                        <i className="fa-grey fa-solid fa-circle" />
                                                        <i className="fa-grey fa-solid fa-circle" />
                                                    </div>
                                                    <div className="price-dev">
                                                        <div className="price-inner-content">
                                                            <h5>$475/yr</h5>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="starter-inner-part">
                                                    <div className="starter-inner-content">
                                                        <h2>Pro</h2>
                                                        <p>For schools who are just getting started with coaching leadership development.</p>
                                                        <h4>What’s Included? </h4>
                                                        <div className="start-list">
                                                            <ul className="pro-ul">
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Unlimited storage and surveys for up to 5 coaches</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Printable custom reports</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Preloaded questions</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>AI generated analysis</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Printable custom reports</h5></li>


                                                            </ul>
                                                            <div className="buy-now-div">
                                                                <Link to="/propage"><button className="buy-now-btn"><span>Buy Now</span><img src={ArrowIcon} /></button></Link>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3">
                                        <div className="premier">
                                            <div className="starter">
                                                <div className="starter-content">
                                                    <div className="fa-icon-dev">
                                                        <i className="fa-blue fa-solid fa-circle" />
                                                        <i className="fa-grey fa-solid fa-circle" />
                                                        <i className="fa-grey fa-solid fa-circle" />
                                                        <i className="fa-grey fa-solid fa-circle" />
                                                    </div>
                                                    <div className="price-dev">
                                                        <div className="price-inner-content">
                                                            <h5>$475/yr</h5>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="starter-inner-part">
                                                    <div className="starter-inner-content">
                                                        <h2>Premier</h2>
                                                        <p>For schools who are just getting started with coaching leadership development.</p>
                                                        <h4>What’s Included? </h4>
                                                        <div className="start-list">
                                                            <ul className="premier-ul">
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Unlimited storage and surveys for up to 5 coaches</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Printable custom reports</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Preloaded questions</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>AI generated analysis</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Printable custom reports</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Preloaded questions</h5></li>

                                                            </ul>
                                                            <div className="buy-now-div">
                                                                <Link to="/premierpage"> <button className="buy-now-btn"><span>Buy Now</span><img src={ArrowIcon} /></button></Link>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3">
                                        <div className="elite">
                                            <div className="starter">
                                                <div className="starter-content">
                                                    <div className="fa-icon-dev">
                                                        <i className="fa-blue fa-solid fa-circle" />
                                                        <i className="fa-grey fa-solid fa-circle" />
                                                        <i className="fa-grey fa-solid fa-circle" />
                                                        <i className="fa-grey fa-solid fa-circle" />
                                                    </div>
                                                    <div className="price-dev">
                                                        <div className="price-inner-content">
                                                            <h5>$475/yr</h5>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="elite-inner-part">
                                                    <div className="elite-inner-content">
                                                        <h2>Elite</h2>
                                                        <p>For schools that want unlimited access to build coaches, culture, and athletic director leadership.</p>
                                                        <h4>What’s Included? </h4>
                                                        <div className="elite-list">
                                                            <ul className="elite-ul">
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Unlimited storage and surveys for up to 5 coaches</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Printable custom reports</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Preloaded questions</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>AI generated analysis</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Printable custom reports</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>Preloaded questions</h5></li>
                                                                <li><i className="fa-regular fa-circle-check" /><h5>AI generated analysis</h5></li>
                                                            </ul>
                                                            <div className="buy-now-div">
                                                                <button className="buy-now-btn"><span>Buy Now</span><img src={ArrowIcon} /></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}

                                </div>

                                {/* <div className="culture-content">
                                    <div className="culture-inner-content">
                                        <h2>Culture and Coach Training</h2>
                                        <p>If you want more than just an opinion survey system, culture and coach training for your staff and your community is what's next.</p>
                                        <button className="culture-btn" onClick={()=>{
                            window.open(ZENDDESK_FAQ)
                          }}><span>CONTACT US</span></button>
                                    </div>

                                </div> */}
                                <div className="culture-content">
                                    <div className="culture-inner-content">
                                        <h2>Get Started for Free</h2>
                                        <p>We’re confident you’ll love our software. 
Get started today with a risk-free trial.</p>
{
                                this.state.getAllPlanData?.filter((item: any) => item?.id === 1).map((item: any, index: number) => {
                                    return (
<button className="culture-btn" key={index} onClick={() => {
                                                    this.buyPlanHandler(item)
                                                }}><span>START FOR FREE NOW!</span></button>
                                            )
                                               })
                            }
                                    </div>

                                </div>
                            </div>
                        </div>
                        </div>
                        <Footerpage/>
                        
                        </div>
                    </>
                );
            }
        }
    )
);



const HomeFunction = (props: any) => (
    <AppContextConsumer>{(context) => <Home {...context} history={props?.history} />}</AppContextConsumer>
);
export default withRouter(HomeFunction);





// WEBPACK FOOTER //
// ./src/pages/director/price/price.tsx